import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLatestAuditsEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 159,
	height: 120,
	viewBox: "0 0 159 120",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "latest-audits-empty-state-clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_17002",
			"data-name": "Rectangle 17002",
			width: 159,
			height: 120,
			transform: "translate(1231 483)",
			fill: "#fff",
			stroke: "#707070",
			strokeWidth: 1
		})
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "latest-audits-empty-state-linear-gradient",
		x1: .365,
		y1: .372,
		x2: -.108,
		y2: 1.114,
		gradientUnits: "objectBoundingBox",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: 0,
			stopColor: "#7284fa"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#3b3387"
		})]
	})] }), /* @__PURE__ */ _jsx("g", {
		id: "Mask_Group_14466",
		"data-name": "Mask Group 14466",
		transform: "translate(-1231 -483)",
		clipPath: "url(#latest-audits-empty-state-clip-path)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_14045",
			"data-name": "Group 14045",
			transform: "translate(-5927.308 -2010.958)",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Group_14042",
				"data-name": "Group 14042",
				transform: "translate(7140.308 2456.649)",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Component_1_1",
					"data-name": "Component 1 \\u2013 1",
					transform: "translate(0 0)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_39283",
						"data-name": "Path 39283",
						d: "M62.594.026c19.937.532,40.135,9.206,45.4,29.45,2.587,9.955-.809,20.516,2.431,30.339,3.276,9.933,13.671,12.836,20.793,19.484,8.6,8.026,11.168,21.943,5.431,32.246-6.191,11.12-21.159,16.674-33.326,12.368-10.5-3.717-17.608-13.2-26.907-19.25a46.086,46.086,0,0,0-27.5-7.289c-5.571.316-11.091,1.646-16.664,1.372-15.425-.758-28.005-14.267-31.2-29.055S2.37,39.447,9.383,25.979c2.694-5.173,5.836-10.255,10.326-14.049,6.565-5.547,15.3-7.8,23.713-9.879A72.48,72.48,0,0,1,62.594.026Z",
						transform: "matrix(0.643, -0.766, 0.766, 0.643, 0, 107.031)",
						fill: "#7b8efa",
						opacity: .137
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Group_14033",
					"data-name": "Group 14033",
					transform: "translate(72.884 53.331)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_949",
						"data-name": "Group 949",
						transform: "translate(0 0)",
						children: [
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_905",
								"data-name": "Group 905",
								children: [
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_9912",
										"data-name": "Rectangle 9912",
										width: 64.733,
										height: 88.524,
										rx: 5,
										transform: "translate(0 0)",
										fill: "#8a98f2"
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_9913",
										"data-name": "Rectangle 9913",
										width: 59.217,
										height: 83.696,
										transform: "translate(2.758 2.389)",
										fill: "#f1f9ff"
									}),
									/* @__PURE__ */ _jsx("path", {
										id: "Path_1605",
										"data-name": "Path 1605",
										d: "M-1274.383,246.668v3.016a3.014,3.014,0,0,0,3.013,3.015h16.183a3.014,3.014,0,0,0,3.013-3.015v-3.016Z",
										transform: "translate(1295.781 -246.668)",
										fill: "#172975"
									})
								]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_916",
								"data-name": "Group 916",
								transform: "translate(6.674 16.015)",
								children: [/* @__PURE__ */ _jsxs("g", {
									id: "Group_908",
									"data-name": "Group 908",
									transform: "translate(38.668)",
									children: [/* @__PURE__ */ _jsx("g", {
										id: "Group_906",
										"data-name": "Group 906",
										transform: "translate(0 1.836)",
										children: /* @__PURE__ */ _jsx("path", {
											id: "Path_1606",
											"data-name": "Path 1606",
											d: "M-1190.5,309.108h-10.71V298.4h10.71Zm-10.205-.5h9.7v-9.7h-9.7Z",
											transform: "translate(1201.206 -298.398)",
											fill: "#a8ccff"
										})
									}), /* @__PURE__ */ _jsx("g", {
										id: "Group_907",
										"data-name": "Group 907",
										transform: "translate(1.559)",
										children: /* @__PURE__ */ _jsx("path", {
											id: "Path_1607",
											"data-name": "Path 1607",
											d: "M-1192.626,303.471a.756.756,0,0,1-.583-.274l-3.3-4a.756.756,0,0,1,.1-1.065.757.757,0,0,1,1.065.1l2.621,3.171,4.741-7.958a.757.757,0,0,1,1.037-.263.757.757,0,0,1,.263,1.037l-5.291,8.88a.757.757,0,0,1-.592.367Z",
											transform: "translate(1196.687 -293.077)",
											fill: "#2cd5c4"
										})
									})]
								}), /* @__PURE__ */ _jsxs("g", {
									id: "Group_915",
									"data-name": "Group 915",
									transform: "translate(0 3.295)",
									children: [/* @__PURE__ */ _jsxs("g", {
										id: "Group_912",
										"data-name": "Group 912",
										transform: "translate(6.61 0.122)",
										children: [/* @__PURE__ */ _jsx("g", {
											id: "Group_909",
											"data-name": "Group 909",
											children: /* @__PURE__ */ _jsx("rect", {
												id: "Rectangle_9914",
												"data-name": "Rectangle 9914",
												width: 23.793,
												height: 1.045,
												fill: "#a9c2ff"
											})
										}), /* @__PURE__ */ _jsxs("g", {
											id: "Group_911",
											"data-name": "Group 911",
											transform: "translate(0 2.334)",
											children: [/* @__PURE__ */ _jsx("rect", {
												id: "Rectangle_9916",
												"data-name": "Rectangle 9916",
												width: 6.486,
												height: 1.045,
												transform: "translate(17.307)",
												fill: "#a9c2ff"
											}), /* @__PURE__ */ _jsx("rect", {
												id: "Rectangle_9917",
												"data-name": "Rectangle 9917",
												width: 15.51,
												height: 1.045,
												fill: "#a9c2ff"
											})]
										})]
									}), /* @__PURE__ */ _jsxs("g", {
										id: "Group_914",
										"data-name": "Group 914",
										children: [/* @__PURE__ */ _jsx("g", {
											id: "Group_913",
											"data-name": "Group 913",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_1608",
												"data-name": "Path 1608",
												d: "M-1311.977,303.682l-1.064.3-.22-.845,1.588-.507h.726v5.956h-1.031Z",
												transform: "translate(1313.261 -302.626)",
												fill: "#a9c2ff"
											})
										}), /* @__PURE__ */ _jsx("path", {
											id: "Path_1609",
											"data-name": "Path 1609",
											d: "M-1304.581,318.081a.376.376,0,0,1,.376-.376.376.376,0,0,1,.376.376.376.376,0,0,1-.376.376A.376.376,0,0,1-1304.581,318.081Z",
											transform: "translate(1307.576 -312.501)",
											fill: "#a9c2ff"
										})]
									})]
								})]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_928",
								"data-name": "Group 928",
								transform: "translate(6.628 32.014)",
								children: [/* @__PURE__ */ _jsxs("g", {
									id: "Group_919",
									"data-name": "Group 919",
									transform: "translate(38.797)",
									children: [/* @__PURE__ */ _jsx("g", {
										id: "Group_917",
										"data-name": "Group 917",
										transform: "translate(0 1.836)",
										children: /* @__PURE__ */ _jsx("path", {
											id: "Path_1610",
											"data-name": "Path 1610",
											d: "M-1190.256,355.471h-10.71v-10.71h10.71Zm-10.205-.5h9.7v-9.7h-9.7Z",
											transform: "translate(1200.966 -344.761)",
											fill: "#a8ccff"
										})
									}), /* @__PURE__ */ _jsx("g", {
										id: "Group_918",
										"data-name": "Group 918",
										transform: "translate(1.559)",
										children: /* @__PURE__ */ _jsx("path", {
											id: "Path_1611",
											"data-name": "Path 1611",
											d: "M-1192.385,349.833a.757.757,0,0,1-.583-.275l-3.3-4a.757.757,0,0,1,.1-1.065.757.757,0,0,1,1.065.1l2.621,3.171,4.742-7.958a.756.756,0,0,1,1.037-.263.756.756,0,0,1,.263,1.037l-5.291,8.88a.757.757,0,0,1-.592.367Z",
											transform: "translate(1196.447 -339.439)",
											fill: "#2cd5c4"
										})
									})]
								}), /* @__PURE__ */ _jsxs("g", {
									id: "Group_927",
									"data-name": "Group 927",
									transform: "translate(0 3.295)",
									children: [/* @__PURE__ */ _jsxs("g", {
										id: "Group_921",
										"data-name": "Group 921",
										children: [/* @__PURE__ */ _jsx("g", {
											id: "Group_920",
											"data-name": "Group 920",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_1612",
												"data-name": "Path 1612",
												d: "M-1313.394,354.13l2.022-1.72c.805-.68,1.1-1.057,1.1-1.585a.881.881,0,0,0-.948-.914c-.537,0-.906.294-1.359.881l-.73-.57a2.408,2.408,0,0,1,2.164-1.233,1.762,1.762,0,0,1,1.938,1.77c0,.923-.5,1.418-1.527,2.273l-1.208,1.007h2.793v.906h-4.245Z",
												transform: "translate(1313.394 -348.988)",
												fill: "#a9c2ff"
											})
										}), /* @__PURE__ */ _jsx("path", {
											id: "Path_1613",
											"data-name": "Path 1613",
											d: "M-1299.069,364.456a.374.374,0,0,1,.374-.373.374.374,0,0,1,.374.373.374.374,0,0,1-.374.374A.374.374,0,0,1-1299.069,364.456Z",
											transform: "translate(1304.012 -358.874)",
											fill: "#a9c2ff"
										})]
									}), /* @__PURE__ */ _jsx("g", {
										id: "Group_926",
										"data-name": "Group 926",
										transform: "translate(6.853 0.122)",
										children: /* @__PURE__ */ _jsxs("g", {
											id: "Group_925",
											"data-name": "Group 925",
											children: [/* @__PURE__ */ _jsx("g", {
												id: "Group_922",
												"data-name": "Group 922",
												children: /* @__PURE__ */ _jsx("rect", {
													id: "Rectangle_9918",
													"data-name": "Rectangle 9918",
													width: 25.002,
													height: 1.045,
													fill: "#a9c2ff"
												})
											}), /* @__PURE__ */ _jsxs("g", {
												id: "Group_924",
												"data-name": "Group 924",
												transform: "translate(0 2.334)",
												children: [/* @__PURE__ */ _jsx("rect", {
													id: "Rectangle_9920",
													"data-name": "Rectangle 9920",
													width: 6.815,
													height: 1.045,
													transform: "translate(18.186)",
													fill: "#a9c2ff"
												}), /* @__PURE__ */ _jsx("rect", {
													id: "Rectangle_9921",
													"data-name": "Rectangle 9921",
													width: 16.298,
													height: 1.045,
													fill: "#a9c2ff"
												})]
											})]
										})
									})]
								})]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_948",
								"data-name": "Group 948",
								transform: "translate(6.074 48.131)",
								children: [
									/* @__PURE__ */ _jsxs("g", {
										id: "Group_931",
										"data-name": "Group 931",
										transform: "translate(39.351)",
										children: [/* @__PURE__ */ _jsx("g", {
											id: "Group_929",
											"data-name": "Group 929",
											transform: "translate(0 1.837)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_1614",
												"data-name": "Path 1614",
												d: "M-1190.256,402.176h-10.71v-10.71h10.71Zm-10.205-.5h9.7v-9.7h-9.7Z",
												transform: "translate(1200.966 -391.466)",
												fill: "#a8ccff"
											})
										}), /* @__PURE__ */ _jsx("g", {
											id: "Group_930",
											"data-name": "Group 930",
											transform: "translate(1.559)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_1615",
												"data-name": "Path 1615",
												d: "M-1192.385,396.538a.756.756,0,0,1-.583-.274l-3.3-4a.757.757,0,0,1,.1-1.065.757.757,0,0,1,1.065.1l2.621,3.171,4.742-7.958a.757.757,0,0,1,1.037-.263.757.757,0,0,1,.263,1.037l-5.291,8.88a.757.757,0,0,1-.592.367C-1192.347,396.537-1192.366,396.538-1192.385,396.538Z",
												transform: "translate(1196.447 -386.144)",
												fill: "#2cd5c4"
											})
										})]
									}),
									/* @__PURE__ */ _jsx("g", {
										id: "Group_936",
										"data-name": "Group 936",
										transform: "translate(7.407 3.417)",
										children: /* @__PURE__ */ _jsxs("g", {
											id: "Group_935",
											"data-name": "Group 935",
											children: [/* @__PURE__ */ _jsx("g", {
												id: "Group_932",
												"data-name": "Group 932",
												children: /* @__PURE__ */ _jsx("rect", {
													id: "Rectangle_9922",
													"data-name": "Rectangle 9922",
													width: 25.002,
													height: 1.045,
													fill: "#a9c2ff"
												})
											}), /* @__PURE__ */ _jsxs("g", {
												id: "Group_934",
												"data-name": "Group 934",
												transform: "translate(0 2.334)",
												children: [/* @__PURE__ */ _jsx("rect", {
													id: "Rectangle_9924",
													"data-name": "Rectangle 9924",
													width: 6.815,
													height: 1.045,
													transform: "translate(18.186)",
													fill: "#a9c2ff"
												}), /* @__PURE__ */ _jsx("rect", {
													id: "Rectangle_9925",
													"data-name": "Rectangle 9925",
													width: 16.298,
													height: 1.045,
													fill: "#a9c2ff"
												})]
											})]
										})
									}),
									/* @__PURE__ */ _jsxs("g", {
										id: "Group_938",
										"data-name": "Group 938",
										transform: "translate(0.48 3.351)",
										children: [/* @__PURE__ */ _jsx("g", {
											id: "Group_937",
											"data-name": "Group 937",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_1616",
												"data-name": "Path 1616",
												d: "M-1313.609,400.689l.706-.657a1.875,1.875,0,0,0,1.51.755.9.9,0,0,0,.993-.887c0-.567-.517-.886-1.322-.886h-.468l-.164-.632,1.552-1.65h-2.487v-.879h3.8v.755l-1.6,1.642c.911.131,1.691.6,1.691,1.633a1.839,1.839,0,0,1-2.011,1.814A2.725,2.725,0,0,1-1313.609,400.689Z",
												transform: "translate(1313.609 -395.854)",
												fill: "#a9c2ff"
											})
										}), /* @__PURE__ */ _jsx("path", {
											id: "Path_1617",
											"data-name": "Path 1617",
											d: "M-1300.568,411.038a.365.365,0,0,1,.365-.365.366.366,0,0,1,.366.365.366.366,0,0,1-.366.365A.365.365,0,0,1-1300.568,411.038Z",
											transform: "translate(1305.068 -405.559)",
											fill: "#a9c2ff"
										})]
									}),
									/* @__PURE__ */ _jsxs("g", {
										id: "Group_947",
										"data-name": "Group 947",
										transform: "translate(0 17.28)",
										children: [
											/* @__PURE__ */ _jsx("g", {
												id: "Group_940",
												"data-name": "Group 940",
												transform: "translate(39.38 0.903)",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_939",
													"data-name": "Group 939",
													children: /* @__PURE__ */ _jsx("path", {
														id: "Path_1618",
														"data-name": "Path 1618",
														d: "M-1190.172,449.545h-10.71v-10.71h10.71Zm-10.206-.5h9.7v-9.7h-9.7Z",
														transform: "translate(1200.882 -438.835)",
														fill: "#a8ccff"
													})
												})
											}),
											/* @__PURE__ */ _jsx("g", {
												id: "Group_945",
												"data-name": "Group 945",
												transform: "translate(7.436 2.484)",
												children: /* @__PURE__ */ _jsxs("g", {
													id: "Group_944",
													"data-name": "Group 944",
													children: [/* @__PURE__ */ _jsx("g", {
														id: "Group_941",
														"data-name": "Group 941",
														children: /* @__PURE__ */ _jsx("rect", {
															id: "Rectangle_9926",
															"data-name": "Rectangle 9926",
															width: 25.002,
															height: 1.045,
															fill: "#a9c2ff"
														})
													}), /* @__PURE__ */ _jsxs("g", {
														id: "Group_943",
														"data-name": "Group 943",
														transform: "translate(0 2.334)",
														children: [/* @__PURE__ */ _jsx("rect", {
															id: "Rectangle_9928",
															"data-name": "Rectangle 9928",
															width: 6.815,
															height: 1.045,
															transform: "translate(18.186)",
															fill: "#a9c2ff"
														}), /* @__PURE__ */ _jsx("rect", {
															id: "Rectangle_9929",
															"data-name": "Rectangle 9929",
															width: 16.298,
															height: 1.045,
															fill: "#a9c2ff"
														})]
													})]
												})
											}),
											/* @__PURE__ */ _jsxs("g", {
												id: "Group_946",
												"data-name": "Group 946",
												transform: "translate(1 2)",
												children: [/* @__PURE__ */ _jsx("path", {
													id: "Path_1619",
													"data-name": "Path 1619",
													d: "M-1300.484,458.407a.366.366,0,0,1,.365-.365.366.366,0,0,1,.366.365.366.366,0,0,1-.366.366A.366.366,0,0,1-1300.484,458.407Z",
													transform: "translate(1304.493 -454.511)",
													fill: "#a9c2ff"
												}), /* @__PURE__ */ _jsx("text", {
													id: "_4",
													"data-name": 4,
													transform: "translate(1 4)",
													fill: "#a9c2ff",
													fontSize: 8,
													fontFamily: "Poppins-Medium, Poppins",
													fontWeight: 500,
													children: /* @__PURE__ */ _jsx("tspan", {
														x: -2.54,
														y: 0,
														children: "4"
													})
												})]
											})
										]
									})
								]
							})
						]
					})
				})]
			}), /* @__PURE__ */ _jsx("g", {
				id: "Group_14043",
				"data-name": "Group 14043",
				transform: "translate(7183.463 2533.479)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group_12291",
					"data-name": "Group 12291",
					transform: "translate(0 0)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Path_25046",
							"data-name": "Path 25046",
							d: "M259.1,106.74l.836-.707,1.083.346.621.9-.284.772-.88.51.334.089-.061.272-1.381.629c-.332-.346-1.452-.612-1.63-.8l.924-.794Z",
							transform: "translate(-223.258 -101.55)",
							fill: "#aa6755"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_25047",
							"data-name": "Path 25047",
							d: "M81.738,541.65l-.032.315-.107,1.047,2.086,1.273,1.2-.934-.99-1.16-.092-.056-.049.121Z",
							transform: "translate(-73.103 -472.908)",
							fill: "#4b505b"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_25048",
							"data-name": "Path 25048",
							d: "M90.582,388.714c-2.364.155-4.559.22-6.283.243l.061,8.085-2.578,14.2.113.034,2.021.606.049-.12,6.776-16.74.237-3.413Z",
							transform: "translate(-73.259 -342.532)",
							fill: "#bcbec0"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_25049",
							"data-name": "Path 25049",
							d: "M144.233,385.38l-.121,1.751.606,4.438.69,16.017h.012l.009-.232,2.062.063,3.254-17,.175-6.947c-2.236.357-4.579.592-6.792.746Z",
							transform: "translate(-126.395 -338.057)",
							fill: "#bcbec0"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_25050",
							"data-name": "Path 25050",
							d: "M155.013,545.485l-.142,0-2.062-.063-.009.232-.031.821,2.165,1.119,1.141-1.018Z",
							transform: "translate(-133.775 -476.121)",
							fill: "#4b505b"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_25051",
							"data-name": "Path 25051",
							d: "M84.931,106.472l-.207-.522.016-.011a3.616,3.616,0,0,0,1.281-3.041,6.072,6.072,0,0,0-.539-2.15,4.755,4.755,0,0,0-.833-1.06,3.182,3.182,0,0,0-2.162-.973c-.316.011-.185.258-.567.063a.682.682,0,0,1-.173-.148l-.105.116a5.7,5.7,0,0,1-1.213.841,2.115,2.115,0,0,0-.868,2.156,2.515,2.515,0,0,1,.129,1.041,3.039,3.039,0,0,1-.455.746,1.345,1.345,0,0,0-.166.491,4.845,4.845,0,0,0,3.549,2.53l0,.016c.019.085.039.169.062.251.1.366.354.753.736.78a1.158,1.158,0,0,0,.506-.12l.982-.4a.267.267,0,0,0,.166-.128.262.262,0,0,0-.025-.183l-.117-.3",
							transform: "translate(-70.946 -95.238)",
							fill: "#aa6755"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_25052",
							"data-name": "Path 25052",
							d: "M45.034,77.61a3.455,3.455,0,0,0-2.087.843A2.05,2.05,0,0,0,41.4,76.962c-.7-.205-1.442-.2-2.129-.473-.826-.323-1.641-1.037-2.461-.8-.738.209-1.2,1.107-1.657,1.9l-.036-.038a3.7,3.7,0,0,0-1.194-.907c-1.472-.608-1.3,1.229-2.434,1.132a2.678,2.678,0,0,1-.761-.353,1.607,1.607,0,0,0-1.463.22,10.477,10.477,0,0,1-1.287.82,9.624,9.624,0,0,0-1.274.452c-.582.349-.463.982-.566,1.558A6.01,6.01,0,0,1,25.5,82.5a5.917,5.917,0,0,1-.956.942,1.472,1.472,0,0,0-.531,1.222c.065.452.423.818.526,1.264a6.5,6.5,0,0,0,.366,1.689,2.1,2.1,0,0,0,.622.91,1.531,1.531,0,0,0,1.329.071,2.781,2.781,0,0,1,1.328-.223c.986.193.932,1.167,1.286,1.932a2.338,2.338,0,0,0,1.142,1.122,2.139,2.139,0,0,0,1.928-.007,2.547,2.547,0,0,0,1.089-2.654,8.046,8.046,0,0,0-.34-1.086,2.834,2.834,0,0,1-.1-.417c-.08-.5.117-1.241-.4-1.582a3.7,3.7,0,0,1-.39-.214.746.746,0,0,1-.2-.311,1.5,1.5,0,0,1-.077-.733,1.346,1.346,0,0,1,.166-.491,3.041,3.041,0,0,0,.455-.746,2.515,2.515,0,0,0-.129-1.041,2.115,2.115,0,0,1,.868-2.156,5.692,5.692,0,0,0,1.213-.841l.105-.116a.681.681,0,0,0,.173.147c.382.195.251-.052.567-.063a3.182,3.182,0,0,1,2.162.973,4.76,4.76,0,0,1,.833,1.06,4.932,4.932,0,0,1,.673,2.3c.036,1.143-.557,1.648-.012,2.8a4.073,4.073,0,0,0,.441.723,3.733,3.733,0,0,0,1.8,1.315c.08,0,.159,0,.238-.01a3.042,3.042,0,0,0,1.132-.323,3.388,3.388,0,0,0,1.774-2.324,1.963,1.963,0,0,1,.322-.949c.177-.2.448-.271.63-.461.755-.793-.686-2.234-.362-3.324.205-.689,1.053-.958,1.237-1.655.206-.779-.61-1.584-1.384-1.631",
							transform: "translate(-24.005 -75.639)"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_25053",
							"data-name": "Path 25053",
							d: "M97.145,122.434c-.253-.046-2.882-.792-2.883-.792.154.024-6.339,4.791-6.954,5.162-1.888,1.139-5.459-.251-7.676-.346a3.349,3.349,0,0,1-.943.715,3.042,3.042,0,0,1-1.132.323c-.079.006-.158.01-.238.01a3.733,3.733,0,0,1-1.8-1.315c-.271-.063-.487-.109-.633-.141l-1.02.041.118.3a.263.263,0,0,1,.024.183.266.266,0,0,1-.166.128l-.982.4a1.158,1.158,0,0,1-.506.12c-.382-.027-.631-.414-.735-.78-.024-.082-.043-.167-.062-.251l-1.936.078-.453.634a8.04,8.04,0,0,1,.34,1.086,2.547,2.547,0,0,1-1.089,2.654,2.139,2.139,0,0,1-1.928.007l-.4,22.727,1.9,8.58s1.367.037,3.48.009c1.631-.022,3.706-.082,5.942-.229l.388-.026c2.093-.146,4.31-.369,6.424-.706.815-.13,1.615-.277,2.386-.443,0,0,1.984-5.392-.867-18.92-.448-2.126-1.068-4.514-1.669-6.63,1.9-1.63,6.993-4.449,8.656-6.321,1.822-2.05,4.436-6.247,4.494-6.237l-.074-.013",
							transform: "translate(-59.878 -114.856)",
							fill: "url(#latest-audits-empty-state-linear-gradient)"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_25072",
							"data-name": "Path 25072",
							d: "M211.241,248.644l-.038,1.193,2.105.766,1.213-.919V248.3l-1.171-.065-.037-.305-.384-.247Z",
							transform: "translate(-183.589 -222.301)",
							fill: "#aa6755"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_25073",
							"data-name": "Path 25073",
							d: "M155.786,236.36l6.5,1.285s-.374,3.962-.371,3.632-8.529-.716-8.529-.716Z",
							transform: "translate(-134.297 -212.652)",
							fill: "#636edb"
						})
					]
				})
			})]
		})
	})]
});
export default SvgLatestAuditsEmptyState;
